const url = '/business/jgProject/'
const url2 = '/business/yhProject/'
const api = {
  // 建管API云养护
  selectJgProjectByPage: url + 'selectJgProjectByPage',
  selectJgProjectAllByList: '/business/yhProject/selectYhProjectAllByList',
  insertJgProject: url + 'insertJgProject',
  updateJgProject: url + 'updateJgProject',
  selectJgProjectByProjectId: url + 'selectJgProjectByProjectId',
  selectJgProjectUserByList: url + 'selectJgProjectUserByList',
  insertJgProjectByProjectId: url + 'insertJgProjectByProjectId',
  deleteDataJgProjectUser: url + 'deleteDataJgProjectUser',
  insertAllJgLocation: '/business/jgLocation/insertAllJgLocation',
  selectJgLocationByList: '/business/jgLocation/selectJgLocationByList',
  updateJgProjectMap: url + 'updateJgProjectMap',
  selectJgProjectMapByProjectId: url2 + 'selectYhProjectMapByProjectId',
  insertJgCad: '/business/jgCad/insertJgCad',

  // 老Saas
  insertProject: '/business/project/insertProject',
  updateProject: '/business/project/updateProject',
  deleteProject: '/business/project/deleteProject',
  selectProjectById: '/business/project/selectProjectById',
  selectProjectByList: '/business/project/selectProjectByList',
  selectProjectByPage: '/business/project/selectProjectByPage',
  // 项目人员管理
  insertProjectUser: '/business/projectUser/insertProjectUser',
  deleteDataProjectUser: '/business/projectUser/deleteDataProjectUser',
  selectProjectUserByList: '/business/projectUser/selectProjectUserByList',
  // 项目区域管理
  insertProjectArea: '/business/projectArea/insertProjectArea',
  updateProjectArea: '/business/projectArea/updateProjectArea',
  deleteDataProjectArea: '/business/projectArea/deleteDataProjectArea',
  selectProjectAreaByList: '/business/projectArea/selectProjectAreaByList',
  // 电子围栏
  insertProjectLocation: '/business/projectArea/insertProjectLocation',
  deleteProjectLocation: '/business/projectArea/deleteProjectLocation',
  deleteLocationByFenceCode: '/business/projectArea/deleteLocationByFenceCode',
  selectProjectAreaById: '/business/projectArea/selectProjectAreaById',
  // 查询电子围栏列表
  projectLocationList: '/business/projectArea/selectProjectLocationList',
  // 查询区域电子围栏列表
  selectProjectAreaLocations: '/business/projectArea/selectProjectAreaLocations',
  selectProjectAreaLocation: '/business/projectArea/selectProjectAreaLocation',
  /** 街道接口 */
  selectVillageList: '/business/project/selectVillageList',
  // 云养护
  selectYhProjectByPage: url2 + 'selectYhProjectByPage',
  selectYhProjectByList: url2 + 'selectYhProjectByList',
  selectYhProjectAllByList: url2 + 'selectYhProjectAllByList',
  insertYhProject: url2 + 'insertYhProject',
  updateYhProject: url2 + 'updateYhProject',
  selectYhProjectByProjectId: url2 + 'selectYhProjectByProjectId',
  selectYhProjectUserByList: url2 + 'selectYhProjectUserByList',
  insertYhProjectByProjectId: url2 + 'insertYhProjectByProjectId',
  deleteDataYhProjectUser: url2 + 'deleteDataYhProjectUser',
  selectYhProjectMapByProjectId: url2 + 'selectYhProjectMapByProjectId',
  insertAllYhLocation: '/business/yhLocation/insertAllYhLocation',
  selectYhLocationByList: '/business/yhLocation/selectYhLocationByList',
  updateYhProjectMap: url2 + 'updateYhProjectMap',
  selectYhWorkerAttendanceByPage: '/business/yhWorkAttendance/selectYhWorkerAttendanceByPage',
  selectAttendanceStatisticsByTimeInterval: '/business/yhWorkAttendance/selectAttendanceStatisticsByTimeInterval',
  selectMplAttendanceList: '/business/yhWorkAttendance/selectMplAttendanceList',
  insertYhProjectArea: '/business/yhProjectArea/insertYhProjectArea',
  updateYhProjectArea: '/business/yhProjectArea/updateYhProjectArea',
  deleteYhProjectArea: '/business/yhProjectArea/deleteYhProjectArea',
  selectYhProjectAreaByProjectAreaId: '/business/yhProjectArea/selectYhProjectAreaByProjectAreaId',
  selectYhProjectAreaByList: '/business/yhProjectArea/selectYhProjectAreaByList',

  selectYhOwnerApplyByPage: '/business/yhOwnerApply/selectYhOwnerApplyByPage',
  updateYhOwnerApplyStatus: '/business/yhOwnerApply/updateYhOwnerApplyStatus',
  deleteYhOwnerApply: '/business/yhOwnerApply/deleteYhOwnerApply',
  insertYhOwnerApply: '/business/yhOwnerApply/insertYhOwnerApply',
  selectOwnerApplyQRCode: '/business/yhOwnerApply/selectOwnerApplyQRCode',
  selectProjectElectronicFence: '/business/yhPicture/selectProjectElectronicFence',
  selectProjectAreaYhPointList: '/business/yhProjectAreaYh/selectProjectAreaYhPointList'
}
export default api
